import { get } from 'lodash';
import { convertToTimeIndexFn, normalizeTimeIndex } from '../../app-main/components/reduxForms/fields/SelectTimeField/ConvertTimeIndex';


export const onToggleSwitch = ({ value, fields, dow }) => {
  if (!value) {
    return fields.splice(0, fields.length, {});
  }

  return fields.splice(0, fields.length, { all_day: true, dow });
};

export const onToggleSetHours = ({ value: isAllDay, fields, dow }) => {
  let setHourValue = {};

  if (isAllDay) {
    setHourValue = { all_day: true, dow };
  } else {
    setHourValue = {
      dow,
      all_day: false,
      start: normalizeTimeIndex(0),
      end: normalizeTimeIndex(1)
    };
  }

  return fields.splice(0, fields.length, setHourValue);
};

export const onAddHours = ({ fields, index }) => {
  const currentRow = fields.get(index);
  const endTime = get(currentRow, 'end.time');
  const newStartTime = convertToTimeIndexFn(endTime, true) + 1;
  const newEndTime = convertToTimeIndexFn(endTime, false) + 2;

  const newRow = {
    ...currentRow,
    start: normalizeTimeIndex(newStartTime),
    end: normalizeTimeIndex(newEndTime)
  };

  return fields.push(newRow);
};
